<template>
  <div class="bottom-bar">
    <div>
      <md-button
        class="vrp-pill-button help-button"
        @click="showHelp"
      >
        <md-icon>help</md-icon>
        Help
      </md-button>
      <md-button
        v-if="!isStudent"
        class="vrp-pill-button tutorial-button"
        @click="showTutorials('SCENARIO_SELECT')"
      >
        Video Tutorials
      </md-button>
    </div>
    <md-button
      v-if="canCreateCase"
      class="vrp-pill-button new-case-button"
      icon="plus"
      type="primary"
      size="large"
      @click="newCase()"
    >
      CREATE NEW
    </md-button>
  </div>
</template>

<script>
export default {
  name: 'bottom-bar',
  props: {
    canCreateCase: {
      type: Boolean,
      default: true,
    },
    isStudent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    newCase() {
      this.$emit('newCase');
    },
    showTutorials(category) {
      this.$emit('showTutorials', category);
    },
    showHelp() {
      window.open('https://vrpatients.atlassian.net/wiki/spaces/VP/overview', '_blank');
    }
  },
};
</script>


<style scoped>
.bottom-bar {
  background-color: #303243 !important;
  height: 65px;
  width: 100%;
  display: flex;
  align-items: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
}

.help-button {
  margin-left: 8px !important;
}

.help-button .md-icon {
  color: white;
}

.new-case-button {
  width: 120px;
  background-color: #62cd63;
  text-transform: capitalize;
}

.tutorial-button {
  width: 120px;
}
</style>
